import ActivityFeedSettings from './ActivityFeedSettings';

export default ActivityFeedSettings;
